import { TERMS_OF_USE_URL, PRIVACY_POLICY_URL } from "@/lib/utils";

export function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-6 px-4">
      <div className="max-w-4xl mx-auto">
        <p className="text-xs text-gray-400 text-center mb-4">
          A pilot by Open Government Products in collaboration with MOE
        </p>
        <div className="flex items-center justify-center gap-6 text-gray-500 text-sm">
          <a
            href={TERMS_OF_USE_URL}
            className="underline hover:text-gray-700 py-2"
          >
            Terms of Use
          </a>
          <a
            href={PRIVACY_POLICY_URL}
            className="underline hover:text-gray-700 py-2"
          >
            Privacy Policy
          </a>
          <a
            href="mailto:matcher@hack2026.gov.sg"
            className="underline hover:text-gray-700 py-2"
          >
            Contact Us
          </a>
        </div>
      </div>
    </footer>
  );
}
